import React from 'react';
import { Box, Typography, Container } from '@mui/material';

interface Step {
  number: number;
  title: string;
}

interface HorizontalStepsProps {
  steps: Step[];
}

const HorizontalSteps: React.FC<HorizontalStepsProps> = ({ steps }) => {
  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Box sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        justifyContent: 'space-between',
        gap: { xs: 2, sm: 6 },
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          display: { xs: 'none', sm: 'block' }, // Hide horizontal line on mobile
          top: '32px',
          left: '50px',
          right: '50px',
          height: '3px',
          backgroundColor: '#e0e0e0',
          zIndex: 0,
        }
      }}>
        {steps.map((step, index) => (
          <Box 
            key={index} 
            sx={{ 
              flex: 1,
              display: 'flex',
              flexDirection: { xs: 'row', sm: 'column' }, // Horizontal layout on mobile
              alignItems: 'center',
              gap: { xs: 3, sm: 0 }, // Add gap for mobile layout
              textAlign: { xs: 'left', sm: 'center' },
              position: 'relative',
              zIndex: 1,
              // Add vertical line for mobile
              '&::before': {
                content: '""',
                position: 'absolute',
                display: index === steps.length - 1 ? 'none' : { xs: 'block', sm: 'none' }, // Hide line for last item on mobile
                top: '48px',
                left: '22px',
                width: '3px',
                height: '40px',
                backgroundColor: '#e0e0e0',
                zIndex: 0,
              }
            }}
          >
            <Box sx={{
              width: { xs: '48px', sm: '64px' }, // Smaller circles on mobile
              height: { xs: '48px', sm: '64px' },
              borderRadius: '50%',
              backgroundColor: 'primary.main',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: { xs: 0, sm: 3 },
              border: '8px solid #f8f9fa',
              flexShrink: 0, // Prevent circle from shrinking on mobile
            }}>
              <Typography sx={{ 
                color: 'white', 
                fontWeight: 'bold',
                fontSize: { xs: '1rem', sm: '1.25rem' }
              }}>
                {step.number}
              </Typography>
            </Box>
            <Typography 
              variant="h5" 
              component="h3" 
              sx={{ 
                fontWeight: 'bold',
                fontSize: { xs: '1.125rem', sm: '1.5rem' }, // Smaller text on mobile
                mb: { xs: 0, sm: 2 }
              }}
            >
              {step.title}
            </Typography>
          </Box>
        ))}
      </Box>
    </Container>
  );
};

export default HorizontalSteps; 